import React from "react";

const PictureInPictureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
    >
      {/* <!-- Dış çerçeve --> */}
      <path
        d="M146.67-160q-27 0-46.84-19.83Q80-199.67 80-226.67v-506.66q0-27 19.83-46.84Q119.67-800 146.67-800h666.66q27 0 46.84 19.83Q880-760.33 880-733.33v506.66q0 27-19.83 46.84Q840.33-160 813.33-160H146.67Zm0-66.67h666.66v-506.66H146.67v506.66Z"
        fill="#fff"
      />

      {/* <!-- Küçük kare (beyaz dolgu ve radius) --> */}
      <rect
        x="444"
        y="-693.33"
        width="330"
        height="251.33"
        rx="24"
        ry="24"
        fill="#fff"
      />

      {/* <!-- Sınır çizgisi (isteğe bağlı) --> */}
      {/* <rect
        x="444"
        y="-693.33"
        width="330"
        height="251.33"
        rx="24"
        ry="24"
        fill="none"
        stroke="#fff"
        strokeWidth="20"
      /> */}
    </svg>
  );
};

export default PictureInPictureIcon;
